import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { PipesModule } from '../pipes/pipes.module';
import {ContactUsModalModule} from '../contact-us-modal/contact-us-modal.module';


@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule, PipesModule,ContactUsModalModule
  ],
  exports:[FooterComponent]
})
export class FooterModule { }
